import { ApiResponseObject } from "../../../types";
import { axios } from "../../../utils/axios";
import {
  ExciseWarehouse,
  IGenerisanjeDozvolaDokumentaPayload,
  IGenerisanjeDozvolaDokumentaProps,
  IResenjaZaSkladisteProps,
  ISkladisteChangePayload,
  ISkladisteIdPayload,
  IZahteviZaSkladisteProps,
} from "./exciseWarehouse.types";

const getSvaAkciznaSkladistaZaDrustvo = (): Promise<
  ApiResponseObject<ExciseWarehouse[]>
> => {
  return axios.get("/svaAkciznaSkladistaZaDrustvo");
};

const createGenerisanjeDozvolaDokumenta = (
  payload: IGenerisanjeDozvolaDokumentaPayload
): Promise<ApiResponseObject<IGenerisanjeDozvolaDokumentaProps>> => {
  return axios.post("/generisanjeDozvolaDokumenta", payload);
};

const createIstorijaZahtevaZaSkladiste = (
  payload: ISkladisteIdPayload
): Promise<ApiResponseObject<IZahteviZaSkladisteProps>> => {
  return axios.post("/istorijaZahtevaZaSkladiste", payload);
};

const createIstorijaResenjaZaSkladiste = (
  payload: ISkladisteIdPayload
): Promise<ApiResponseObject<IResenjaZaSkladisteProps>> => {
  return axios.post("/istorijaResenjaZaSkladiste", payload);
};

const postKreiranjeZahtevaZaIzmenuObnovuIliPrekidVazenjaDozvole = (
  payload: ISkladisteChangePayload
): Promise<ApiResponseObject<number | null>> => {
  return axios.post(
    "/kreiranjeZahtevaZaIzmenuObnovuIliPrekidVazenjaDozvole",
    payload
  );
};

export const exciseWarehouseRepo = {
  getSvaAkciznaSkladistaZaDrustvo,
  createGenerisanjeDozvolaDokumenta,
  createIstorijaZahtevaZaSkladiste,
  createIstorijaResenjaZaSkladiste,
  postKreiranjeZahtevaZaIzmenuObnovuIliPrekidVazenjaDozvole,
};
